import React, { Component } from 'react';
import { Redirect, withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import queryString from 'query-string';
import {
  Row, Col, Badge
} from 'reactstrap';

import { setUserProfile } from '../../../redux/actions/authActions';
import { Publisher } from "./../../pubsub/publisher.js";
import CheckIcon from 'mdi-react/CheckCircleOutlineIcon';
import CircleIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon';
import ChangeIcon from 'mdi-react/RotateLeftIcon';

import { setPlan } from '../../../redux/actions/planActions';
import { subscriptionPlans, appFeatures } from './plans.js';

import TopBar from './../TopBar';
import Footer from './../Footer';

import {
  _getUserSSO,
  _setSSOToken,
  _getSSOToken,
  _doSSOLogout,
  decodeIdToken
} from '../auth/sso/ssoutils';

import {
  _formatNumber
} from '../../helpers/utils';
import {
  _axiosCall
} from '../../helpers/apicalls';

import { _isNewDevSubscriber } from './plans';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './stripe/CheckoutForm';
import CouponForm from './stripe/CouponForm';

import './Payment.scss';

const stripePromise = loadStripe(process.env.STRIPE_PUB_KEY);
const apiUrl = process.env.API_ROOT + '/buyerslist/';

class Pay extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  selectedPlan: false,
	  coupon: false,
	  trial: true,
	  ready: false
	};

	this.logout = this.logout.bind(this);
	this.updateUserProfile = this.updateUserProfile.bind(this);
	this.setCoupon = this.setCoupon.bind(this);
	this._ensureUserFromSSO = this._ensureUserFromSSO.bind(this);
  }

  componentDidMount() {
	var dispatch = this.props.dispatch;
	var plan = this.props.plan;

	// read plan from localStorage or Redux
	var currentPlan = plan && plan.id ? subscriptionPlans.filter(function (p) { return p.id === plan.id; })[0] : false;
	if (!currentPlan && typeof localStorage !== 'undefined' && localStorage.getItem('mpnd-plan')) {
	  var planId = localStorage.getItem('mpnd-plan');
	  var exists = subscriptionPlans.filter(function (p) { return p.id === planId; }).length > 0;
	  if (exists) {
		dispatch(setPlan(planId));
		currentPlan = subscriptionPlans.filter(function (p) { return p.id === planId; })[0];
	  }
	}
	if (currentPlan) {
	  this.setState({ selectedPlan: currentPlan.stripeProductId, coupon: false });
	}

	// Auto-apply coupon from URL param or sessionStorage
	var urlParams = queryString.parse(this.props.location.search);
	var couponCode = urlParams.coupon || sessionStorage.getItem('post_auth_coupon') || '';
	if (couponCode && currentPlan) {
	  this._autoApplyCoupon(couponCode, currentPlan);
	}

	// Ensure user in Redux from MPSSO token
	this._ensureUserFromSSO(function () {
	  // mark page ready to render
	  // (prevents a flicker before we know user/token state)
	  // you can remove ready if you prefer immediate render
	});
  }

  _ensureUserFromSSO(done) {
	var dispatch = this.props.dispatch;
	var reduxUser = this.props.user;
	var tokenObj = _getSSOToken(); // your MPSSO store (id_token, access_token, etc.)

	if (!tokenObj || !tokenObj.id_token) {
	  this.setState({ ready: true });
	  if (typeof done === 'function') done();
	  return;
	}

	// if Redux already has a user, we’re done
	if (reduxUser && reduxUser.id) {
	  this.setState({ ready: true });
	  if (typeof done === 'function') done();
	  return;
	}

	// derive a profile from the id_token
	try {
	  var claims = decodeIdToken(tokenObj.id_token);
	  var profile = {
		id: claims.sub,
		email: claims.email,
		name: claims.name,
		given_name: claims.given_name || '',
		family_name: claims.family_name || '',
		authType: 'sso'
	  };
	  dispatch(setUserProfile(profile));
	  Publisher.publish('login', profile);
	} catch (e) {
	  // if decoding fails, clear token so user can re-auth
	  _doSSOLogout(this.props, setUserProfile);
	}

	this.setState({ ready: true });
	if (typeof done === 'function') done();
  }

  _autoApplyCoupon(couponCode, currentPlan) {
	var self = this;
	fetch(apiUrl + 'stripe/check-coupon', {
	  method: 'post',
	  headers: { 'Content-Type': 'application/json' },
	  body: JSON.stringify({ coupon: couponCode })
	}).then(function (res) {
	  return res.json();
	}).then(function (couponResult) {
	  if (couponResult && couponResult.valid) {
		if (couponResult.duration_in_months && couponResult.duration_in_months > 0 && couponResult.duration_in_months < currentPlan.billingFrequencyMonths) {
		  console.log('Auto-coupon rejected: duration mismatch');
		} else if (couponResult.amount_off && (couponResult.amount_off / 100) > currentPlan.pricePerMonth) {
		  console.log('Auto-coupon rejected: amount exceeds plan price');
		} else {
		  // Allow coupon on trials - it will apply after trial ends
		  self.setState({ coupon: couponResult });
		}
	  } else {
		console.log('Auto-coupon invalid:', couponCode);
	  }
	  // Clear from sessionStorage after attempt
	  sessionStorage.removeItem('post_auth_coupon');
	}).catch(function (err) {
	  console.log('Auto-coupon error:', err);
	  sessionStorage.removeItem('post_auth_coupon');
	});
  }

  async logout() {
	// Clear SSO and Redux user, return to home
	_doSSOLogout(this.props, setUserProfile);
	Publisher.publish("logout", {});
  }

  setCoupon(coupon) {
	this.setState({ coupon: coupon });
  }

  updateUserProfile(payment, callback) {
	var dispatch = this.props.dispatch;
	var user = this.props.user;
	var plan = this.props.plan;

	if (!payment || !payment.id) return false;

	var profile = Object.assign({}, user, {
	  subscriptionPlan: this.state.selectedPlan,
	  subscriptionId: payment.id
	});

	if (payment.status) profile.subscriptionStatus = payment.status;
	if (payment.trial_start) profile.trialStart = payment.trial_start;
	if (payment.trial_end) profile.trialEnd = payment.trial_end;

	var user_id = profile.id;
	if (profile.id) delete profile.id; // server stores id separately
	if (profile.login) delete profile.login;
	if (profile.role) delete profile.role;

	if (user && user.role && Array.isArray(user.role) && user.role.length > 0) {
	  var newRoles = user.role.slice();
	  var subIds = subscriptionPlans.map(function (p) { return p.id; });
	  newRoles = newRoles.filter(function (r) { return subIds.indexOf(r) < 0; });
	  profile.role = newRoles.concat(plan.id);
	} else {
	  profile.role = [plan.id];
	}

	var userData = {
	  url: apiUrl + 'user/update',
	  method: "post",
	  query: {
		id: user_id,
		profile: profile
	  }
	};

	_axiosCall(userData)
	  .then(function (res) {
		if (res && res.profile) {
		  var stored = Object.assign({}, res.profile);
		  stored.id = res.id;
		  dispatch(setUserProfile(stored));
		  if (typeof callback === 'function') callback(stored);
		  return stored;
		} else {
		  return false;
		}
	  })
	  .catch(function (error) {
		console.log("_getUserData error ", error);
		return false;
	  });

	return null;
  }

  render() {
	var user = this.props.user;
	var plan = this.props.plan;
	var selectedPlan = this.state.selectedPlan;
	var coupon = this.state.coupon;
	var trial = this.state.trial;

	// guard: require SSO token
	var tokenObj = _getSSOToken();

	// Resolve current plan
	var currentPlan = plan && plan.id ? subscriptionPlans.filter(function (p) { return p.id === plan.id; })[0] : false;
	if (!currentPlan && typeof localStorage !== 'undefined' && localStorage.getItem('mpnd-plan')) {
	  var plan_id = localStorage.getItem('mpnd-plan');
	  currentPlan = subscriptionPlans.filter(function (p) { return p.id === plan_id; }).length > 0
		? subscriptionPlans.filter(function (p) { return p.id === plan_id; })[0]
		: false;
	}

	// Redirects
	if (!currentPlan) {
	  return <Redirect to={{ pathname: '/pricing' }} />;
	}
	if (!tokenObj || !tokenObj.id_token) {
	  // not authenticated via Auth0 SSO
	  return <Redirect to={{ pathname: '/signin/register' }} />;
	}
	if (user && user.subscriptionPlan && _isNewDevSubscriber(user)) {
	  Publisher.publish("login", user);
	  return <Redirect to={{ pathname: '/dashboard' }} />;
	}

	// compute totals
	var totalAtCheckout = currentPlan.totalAtCheckout;
	if (coupon) {
	  if (coupon.percent_off) {
		totalAtCheckout = Math.round(totalAtCheckout * ((100 - coupon.percent_off) / 100));
	  } else if (coupon.amount_off) {
		totalAtCheckout = Math.round(totalAtCheckout - (coupon.amount_off / 100));
	  }
	}
	var taxes = (totalAtCheckout * 0.08875);
	totalAtCheckout = (parseFloat(totalAtCheckout) + parseFloat(taxes)).toFixed(2);

	return (
	  <div className="plan__wrapper share__wrapper">
		<TopBar goTo={'plans'} buttonText={'Change Plan'} />
		<Row className="login-container signup">
		  <Col lg={6} className="pt-0 signin">
			<div className="payment-container widget-container">
			  <div className="payment-header">
				<Link className="topbar__logo" to="/" style={{ display: "block", margin: "15px auto" }} />
			  </div>

			  <div className="payment-elements">
				<div className="select-plan-container">
				  <div className={'plan-type selected'}>
					<div className="select-banner">
					  <span>{currentPlan.checkTitle}</span>
					</div>
					<div className={'trial-plan-text'}>
					  {coupon ? (
						<h3>
						  <span style={{ textDecoration: 'line-through', color: '#000', fontSize: '0.7em', marginRight: 8 }}>
							${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)}
						  </span>
						  ${coupon.percent_off
							? Math.round(currentPlan.pricePerMonth * ((100 - coupon.percent_off) / 100))
							: _formatNumber(currentPlan.pricePerMonth - (coupon.amount_off / 100))}
						</h3>
					  ) : (
						<h3>${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)}</h3>
					  )}
					  <div className="time small-text">Per Month</div>
					  <h6 style={{ marginBottom: 20 }}>
						<span style={{ fontSize: 14, fontWeight: 600, color: '#363347', textTransform: 'uppercase' }}>{currentPlan.name} PLAN</span>
					  </h6>
					  <div className="alt-price">{currentPlan.description}</div>
					</div>
				  </div>
				</div>

				<hr />
				<div className="charge-amount">
				  <div className="checkout-line">{currentPlan.name} Subscription <strong>${currentPlan.totalAtCheckout}</strong></div>
				  {coupon && coupon.name ?
					<div className="checkout-line">{coupon.name} {coupon.percent_off ? <strong>-{coupon.percent_off}% Off</strong> : <strong>-${Math.round(coupon.amount_off / 100)} Off</strong>}</div>
					: null}
				  {trial ?
					<div className="checkout-line">7-day Free Trial <span className="charge-text">(End on {moment().add(7, 'days').format('M/D/YYYY')})</span></div>
					: null}
				  {trial ?
					<div className="checkout-line">Payment After Trial <span className="charge-text">(+${parseFloat(taxes).toFixed(2)} Sales Tax)</span>  <strong>${totalAtCheckout}</strong></div>
					:
					<div className="checkout-line">NYC Sales Tax  <strong>${parseFloat(taxes).toFixed(2)}</strong></div>
				  }
				  <div className="total-payment">{`Today's Total`} <strong>${trial ? 0 : parseFloat(totalAtCheckout).toFixed(2)}</strong></div>
				  <span className="charge-text">
					Billed once per {currentPlan.billingFrequency}.  Cancel anytime.
				  </span>
				</div>

				<div>
				  <Elements stripe={stripePromise}>
					<CouponForm user={user} setCoupon={this.setCoupon} currentCoupon={coupon} currentPlan={currentPlan} trial={trial} />
				  </Elements>
				</div>

				<hr />

				<Elements stripe={stripePromise}>
				  <CheckoutForm
					selectedPlan={selectedPlan}
					totalAtCheckout={totalAtCheckout}
					currentPlan={currentPlan}
					user={user}
					coupon={coupon}
					updateUserProfile={this.updateUserProfile}
					trial={trial}
				  />
				</Elements>

				<a className="cancel-payment" href="javascript:void" onClick={this.logout}>{`Cancel, I'll try another time.`}</a>
			  </div>

			  <p className="disclaimer">
				By creating an account, you agree to our{' '}
				<a href="https://marketproof.com/terms-of-use" target="_blank" rel="noreferrer">Terms of Service</a>{' '}and{' '}
				<a href="https://marketproof.com/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>.
			  </p>
			</div>
		  </Col>

		  <Col lg={6} className="signin-hero-container" style={{ marginTop: 100 }}>
			<div className="signin-hero">
			  <a href="https://marketproof.com/new-development" target="_blank" rel="noreferrer"><h1>{`Start your 7-day`}<br />{`free trial`}</h1></a>
			  <h3 style={{ marginBottom: 0 }}>
				{coupon ? (
				  <span style={{ color: '#9600BF', fontWeight: 800 }}>
					<span style={{ textDecoration: 'line-through', color: '#000', fontSize: '0.7em', marginRight: 8 }}>
					  ${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)}
					</span>
					${coupon.percent_off
					  ? Math.round(currentPlan.pricePerMonth * ((100 - coupon.percent_off) / 100))
					  : _formatNumber(currentPlan.pricePerMonth - (coupon.amount_off / 100))} / month
				  </span>
				) : (
				  <span style={{ color: '#9600BF', fontWeight: 800 }}>
					${currentPlan.pricePerMonth % 1 != 0 ? currentPlan.pricePerMonth : _formatNumber(currentPlan.pricePerMonth)} / month
				  </span>
				)}
			  </h3>
			  <h6 style={{ marginBottom: 20 }}>
				<span style={{ fontSize: 15, fontWeight: 600, color: '#363347', textTransform: 'uppercase' }}>{currentPlan.name} PLAN</span>
			  </h6>
			  <hr />
			  <div className="plan-features">
				{appFeatures.map(function (feature) {
				  if (feature.plans.indexOf(plan.id) >= 0) {
					return <p className="pricing-card__feature"><CheckIcon size={16} color={'#780F9E'} style={{ marginTop: -3 }} /> {feature.name}</p>;
				  } else {
					return <p className="pricing-card__feature pricing-card__feature--inactive"><CircleIcon size={16} style={{ marginTop: -3 }} /> {feature.name}</p>;
				  }
				})}
			  </div>
			  <hr />
			  <Link to={`/pricing`} style={{ color: '#9600BF', textAlign: 'right' }}><ChangeIcon size={16} style={{ marginTop: -2 }} /> Change Plan </Link>
			</div>
		  </Col>
		</Row>
		<Footer />
	  </div>
	);
  }
}

export default connect(function (state) {
  return { user: state.user, plan: state.plan };
})(withRouter(Pay));
